exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.profile-component-container{\n    width: 300px;\n    height: 300px;\n    overflow-y: hidden;\n    opacity:1;\n}\n\n\n\n.profile-component-info{\n    padding-top: 100px;\n}\n\n\n\n.profile-component-footer{\n    margin:0 auto;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    text-align: center;\n}\n\n\n\n#replay{\n  opacity :0;\n}\n\n\n\n.addPadding{\n  padding-top: 40px;\n}\n\n\n\n#home{\n  opacity :0;\n}\n\n\n\n.small-text{\n  font-size: 18px;\n}\n\n\n\n.small-mid-text{\n  font-size: 25px;\n}\n\n\n\n.medium-text{\n  font-size: 28px;\n}\n\n\n\n.large-text{\n  font-size: 32px;\n}\n\n\n\n.slide {\n  overflow: hidden;\n    position: absolute;\n    display: block;\n    color:white; \n    text-align: center;\n    width: 300px;\n    font-size: 28px;\n    opacity:0;\n    left:-5px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/haydenso/Desktop/Code/Projects/haydensookchand/website_source/src/app/profile/profile.component.css
// module id = ../../../../../src/app/profile/profile.component.css
// module chunks = main